import { createSelector } from '@ngrx/store';
import { cartState } from '../root';

export const getCartMenuFlowByTempId = (tempId: number) => createSelector(cartState, (cart) => cart.itemsMenuFlow.find((item) => item._Id === tempId) || null);
